<template>
    <div class="p-grid">
        <Toast />
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('PositionOffer.list.Search') }}</strong>
                </h4>
                <h5 style="font-weight: 100">
                    {{ $t('PositionOffer.list.Heading2') }}
                </h5>
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-md-3">
                        <label for="nameuser">{{ $t('PositionOffer.list.Primary') }}</label>
                        <Dropdown
                            v-model="occupation_first"
                            :options="Primarydropdown"
                            optionLabel="text"
                            optionValue="id"
                            :placeholder="$t('PositionOffer.list.placeholder')"
                            name="first_category"
                            id="first_category"
                            @change="balankall(), (searchclicked = false)"
                        />
                        <!-- @change="searchPosition(); -->
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="nameuser">{{ $t('PositionOffer.list.Secondary') }}</label>
                        <Dropdown
                            v-model="occupation_second"
                            :options="SeconddropdownValue"
                            optionLabel="text"
                            optionValue="id"
                            :placeholder="$t('PositionOffer.list.placeholder')"
                            name="first_category"
                            id="first_category"
                            @click="getSecondOccupationList"
                            @change="blankthird(), (searchclicked = false)"
                            :disabled="disablesecond"
                        />
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="nameuser">{{ $t('PositionOffer.list.Tertiary') }}</label>
                        <Dropdown
                            v-model="occupation_third"
                            :options="Tertiarydropdown"
                            optionLabel="text"
                            optionValue="id"
                            :placeholder="$t('PositionOffer.list.placeholder')"
                            name="first_category"
                            id="first_category"
                            @click="getThirdOccupationList"
                            @change="searchclicked = false"
                            :disabled="disablethird"
                        />
                    </div>
                </div>

                <div class="p-d-flex p-jc-between p-ai-lg-center p-ai-start p-mt-0 p-flex-column p-flex-lg-row">
                    <div class="p-mb-4 p-mb-lg-0">
                        <!-- <Button :label="$t('button.today')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="today"></Button>
                        <Button :label="$t('button.lastWeek')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastweek"></Button>
                        <Button :label="$t('button.lastMonth')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastmonth"></Button>
                        <Button :label="$t('button.last6Months')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastsixmonth"></Button>
                         <Button :label="$t('button.lastYear')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastyear"></Button>  -->
                    </div>
                    <div class="p-mb-4 p-mb-lg-0">
                        <Button :label="$t('button.search')" icon="pi pi-search" iconPos="left" class="p-button p-component p-button p-button-sm p-mr-2 p-mb-2" @click="searchPosition"></Button>
                        <Button :label="$t('button.reset')" icon="pi pi-replay" iconPos="left" class="p-button p-component p-button p-button-sm p-mr-2 p-mb-2" @click="resetPosition"></Button>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-col-12">
            <div class="card">
                <div class="p-d-flex p-jc-between p-mb-2">
                    <div>
                        <h5>{{ $t('PositionOffer.list.Heading') }}</h5>
                    </div>
                </div>
                <div class="p-mb-4 p-mb-lg-0 page">
                    <label for="order">{{ $t('PositionOffer.list.Record') }} {{ pagination.total_records }} </label>
                </div>
                <br />
                <DataTable :paginator="false" :value="Positions" class="p-datatable-gridlines" :rows="10" dataKey="id" :loading="loading1" :rowHover="true" :filters="filters1" responsiveLayout="scroll" v-model:selection="selected">
                    <!-- v-model:selection="selected" -->
                    <ConfirmDialog group="dialog" />

                    <template #empty>문의를 찾을 수 없습니다</template>
                    <template #loading>어드민 정보 로딩중..</template>

                    <!-- <column selectionMode="multiple" style="width: 16px; text-align: center" /> -->
                    <Column field="slNO" :header="$t('PositionOffer.list.No')" style="width: 5%">
                        <template #body="{ index }">
                            <span class="p-column-title">#</span>
                            {{ pagination.current_page * pagination.pagination_limit - pagination.pagination_limit + (index + 1) }}
                        </template>
                    </Column>
                    <Column field="name" :header="$t('PositionOffer.list.CompanyName')" style="min-width: 10rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Name</span>
                            {{ data.company_name }}
                        </template>
                    </Column>
                    <Column field="name" :header="$t('PositionOffer.list.JobPosttitle')" style="min-width: 10rem">
                        <template #body="{ data }">
                            <span class="p-column-title">User Type</span>
                            {{ data.announcement_title }}
                        </template>
                    </Column>
                    <Column :header="$t('PositionOffer.list.Action')" style="width: 5%">
                        <template #body="{ data }">
                            <span class="p-column-title">Balance</span>
                            <!-- <p style="display: none">{{ data.mobile }}</p> -->
                            <div style="display: flex">
                                <!-- <router-link v-if="data.id != undefined" :to="{ name: 'PositionOffered', params: { jobId : data.id } }"> <Button label="구직자 찾기" class="p-button2"> </Button> </router-link> -->
                                <!-- <Button label="구직자 찾기" class="p-button2" @click="GetAllValue(data.id)"> </Button> -->
                                <!-- <router-link :to="'/PositionOffer/PositionOffered/' + data.id"></router-link> -->
                                <Button :label="$t('FindJobSeeker')" class="p-button2" @click="FindSeeker(data.id)"> </Button>
                                <!-- <router-link :to="'/Editproductcategory/' + data.id"
                                    ><Button label="info" class="p-button2" ><i class="pi pi-user-edit p-mr-2"></i> </Button>
                                </router-link>
                                <Button icon="pi pi-trash" class="p-button2" @click="confirm(data.id)" /> -->
                            </div>
                        </template>
                    </Column>

                    <!--  -->
                </DataTable>
                <div class="p-paginator p-component p-paginator-bottom">
                    <button @click="paginate(1)" :class="{ 'p-disabled': pagination.current_page === 1 }" class="p-paginator-first p-paginator-element p-link" type="button" :disabled="pagination.current_page === 1">
                        <span class="p-paginator-icon pi pi-angle-double-left"></span>
                        <span class="p-ink"></span>
                    </button>
                    <button @click="paginate(pagination.current_page - 1)" :class="{ 'p-disabled': pagination.current_page === 1 }" class="p-paginator-next p-paginator-element p-link" type="button" :disabled="pagination.current_page === 1">
                        <span class="p-paginator-icon pi pi-angle-left"></span>
                        <span class="p-ink"></span>
                    </button>
                    <span class="p-paginator-pages">
                        <button
                            v-for="(page, index) in get_paginator_page(pagination.total_pages, pagination.current_page)"
                            :key="index"
                            @click="paginate(page)"
                            class="p-paginator-page p-paginator-element p-link"
                            :class="{ 'p-highlight': page === pagination.current_page }"
                            type="button"
                        >
                            {{ page }}<span class="p-ink"></span>
                        </button>
                    </span>
                    <button
                        @click="paginate(pagination.current_page + 1)"
                        :class="{ 'p-disabled': pagination.current_page === pagination.total_pages }"
                        class="p-paginator-next p-paginator-element p-link"
                        type="button"
                        :disabled="pagination.current_page === pagination.total_pages"
                    >
                        <span class="p-paginator-icon pi pi-angle-right"></span>
                        <span class="p-ink"></span>
                    </button>
                    <button
                        @click="paginate(pagination.total_pages)"
                        :class="{ 'p-disabled': pagination.current_page === pagination.total_pages }"
                        :disabled="pagination.current_page === pagination.total_pages"
                        class="p-paginator-last p-paginator-element p-link"
                        type="button"
                    >
                        <span class="p-paginator-icon pi pi-angle-double-right"></span>
                        <span class="p-ink"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { useRoute } from 'vue-router';
// import validateUsersearch from '../../validations/user/validateUserSearch';
// import { FilterMatchMode, FilterOperator } from 'primevue/api';
import PositionOfferService from '../../service/API/PositionOfferService';
import axios from 'axios';
import utils from '@/service/utils';
// import { json } from 'body-parser';
// import ProductService from '../service/ProductService';
// import axios from 'axios';
export default {
    // components:{
    //     PositionOffered
    // },
    data() {
        return {
            disablesecond: true,
            disablethird: true,
            selected: [],
            selectedItemss: '',
            start_date: '',
            end_date: '',
            render: true,
            display: false,
            position: 'center',
            visibleLeft: false,
            visibleRight: false,
            visibleTop: false,
            visibleBottom: false,
            visibleFull: false,
            dropdownValue: null,
            dropdownValues: '',
            SeconddropdownValues: '',
            SeconddropdownValue: [],
            customer1: null,
            loading1: true,
            idFrozen: false,
            products: null,
            expandedRows: [],
            user: null,
            Primarydropdowns: '',
            // Primarydropdown: JSON.parse(localStorage.getItem('FirstLevel')),
            Primarydropdown: [],
            // Primarydropdown: [
            //     {
            //         text: '요리·서빙',
            //         id: 1,
            //     },
            //     {
            //         text: '운전·배달·물류',
            //         id: 2,
            //     },
            //     {
            //         text: '생산·기술',
            //         id: 3,
            //     },
            //     {
            //         text: '건설·토목·노무',
            //         id: 4,
            //     },
            //     {
            //         text: '유통·판매',
            //         id: 5,
            //     },
            //     {
            //         text: '문화·여가·생활',
            //         id: 6,
            //     },
            //     {
            //         text: '서비스',
            //         id: 7,
            //     },
            //     {
            //         text: '사무·회계·IT',
            //         id: 8,
            //     },
            //     {
            //         text: '영업·상담',
            //         id: 9,
            //     },
            //     {
            //         text: '요양·간호·의료',
            //         id: 10,
            //     },
            //     {
            //         text: '교육·강사',
            //         id: 11,
            //     },
            // ],
            statusdropdowns: '',
            Tertiarydropdown: [],
            Tertiarydropdowns: '',
            statusdropdown: [
                { name: 'Active', code: 'active' },
                { name: 'Inactive', code: 'inactive' },
            ],
            statuses: ['unqualified', 'qualified', 'new', 'negotiation', 'renewal', 'proposal'],
            genders: [
                { name: 'Statistical', code: 'Statistical' },
                { name: 'Coupon', code: 'Coupon' },
                { name: 'Survey reminder', code: 'Survey reminder' },
                { name: 'Manual', code: 'Manual' },
            ],
            pets: [
                { name: 'Yes', code: 'Yes' },
                { name: 'No', code: 'No' },
            ],
            marital_statuss: [
                { name: 'married', code: 'married' },
                { name: 'unmarried', code: 'unmarried' },
            ],
            age_groups: [
                { name: '25~35', code: '25 ~ 35' },
                { name: '35~45', code: '35 ~ 45' },
                { name: '45~55', code: '45 ~ 55' },
                { name: '55~65', code: '55 ~ 65' },
            ],
            dropdownItem: null,
            error: {},
            //params for list
            Ntitle: '',
            Ntype: '',
            // start_date: '',
            // end_date: '',
            id: '',
            notification_type: '',
            productCategoryStatus: '',
            pagination_limit_options: [
                { label: '10개씩 보기', value: 10 },
                { label: '20개씩 보기', value: 20 },
                { label: '50개씩 보기', value: 50 },
                { label: '100개씩 보기', value: 100 },
            ],
            pagination: {
                current_page: 1,
                pagination_limit: 10,
                total_pages: 0,
                total_records: 0,
            },
            occupation_third: '',
            occupation_first: '',
            occupation_second: '',
            Positions: [],
            searchclicked: false,
        };
    },
    customerService: null,
    productService: null,
    created() {
        this.positionOfferService = new PositionOfferService();
    },
    mounted() {
        // this.getPositionslist();

        // console.log('prevpath', this.$router.options.history.state.back);
        if (localStorage.getItem('prev_offered_path') == 'Position Offered') {
            this.searchclicked = true;
            this.GetFirstLevel();
        } else {
            this.GetFirstLevel();
        }
    },
    // beforeMount(){
    //     this.GetFirstLevel();
    // },

    watch: {
        'pagination.pagination_limit'(val) {
            this.getPositionslist({ limit: val, page: 1 });
        },
    },
    methods: {
        getPositionslist() {
            const OfferParams = {
                page: this.pagination.current_page,
                limit: this.pagination.pagination_limit,
                occupation_first: this.occupation_first,
                occupation_second: this.occupation_second == 100999 ? '' : this.occupation_second,
                occupation_third: this.occupation_third == 100999 ? '' : this.occupation_third,
            };
            this.loading1 = true;
            this.positionOfferService
                .getPositionOfferList(OfferParams)
                .then((res) => {
                    this.Positions = res.data.data;
                    this.totalrecords = res.data.total_records;
                    if (localStorage.getItem('prev_offered_path') == 'Position Offered') {
                        this.getSecondOccupationList();
                        setTimeout(() => {
                            this.getThirdOccupationList();
                            localStorage.removeItem('prev_offered_path');
                        }, 500);
                        console.log(this.occupation_first, this.occupation_second, this.occupation_third);
                        localStorage.setItem(
                            'SearchParams',
                            JSON.stringify({
                                page: 1,
                                limit: 10,
                                occupation_first: res.data.default_occu_first_level,
                                occupation_second: this.occupation_second == 100999 ? '' : this.occupation_second,
                                occupation_third: this.occupation_third == 100999 ? '' : this.occupation_third,
                            })
                        );
                        // alert('one');
                    }
                    // else {
                    //     // this.occupation_first = Number(res.data.default_occu_first_level);
                    //     // alert('two');
                    //     console.log('hello');
                    // }

                    this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                    this.loading1 = false;
                    // console.log(res);
                    // console.log(this.occupation_first);
                })
                .catch((err) => console.log(err));
        },
        setPagination(current_page, total_pages, total_records) {
            this.pagination.current_page = current_page;
            this.pagination.total_pages = total_pages;
            this.pagination.total_records = total_records;
        },
        get_paginator_page(total, active) {
            return utils.paginate(total, active);
        },

        paginate(page) {
            this.loading1 = true;
            this.positionOfferService
                .getPositionOfferList({
                    page: page,
                    limit: this.pagination.pagination_limit,
                    occupation_first: this.occupation_first,
                    occupation_second: this.occupation_second == 100999 ? '' : this.occupation_second,
                    occupation_third: this.occupation_third == 100999 ? '' : this.occupation_third,
                })
                .then((res) => {
                    this.Positions = res.data.data;
                    this.pagination.current_page = page;
                    this.loading1 = false;
                    console.log(res.data);
                })
                .catch((err) => console.log(err));
        },
        blankthird() {
            if (this.occupation_second == 100999) {
                this.occupation_third = '';
                this.Tertiarydropdown = [];
                this.disablethird = true;
            } else {
                this.disablethird = false;
            }
        },
        balankall() {
            this.disablesecond = false;
            this.disablethird = true;
            this.SeconddropdownValue = [];
            this.occupation_third = '';
            this.occupation_second = '';
            this.Tertiarydropdown = [];
        },
        GetFirstLevel() {
            this.positionOfferService.FirstOccupation().then((res) => {
                this.Primarydropdown = res;
                // this.occupation_first = res.data.default_occu_first_level;
                console.log(res);
                let storedDate = JSON.parse(localStorage.getItem('SearchParams'));
                setTimeout(() => {
                    if (localStorage.getItem('prev_offered_path') == 'Position Offered') {
                        this.pagination.current_page = Number(storedDate.page);
                        this.occupation_first = Number(storedDate.occupation_first);
                        this.occupation_second = storedDate.occupation_second == '' ? 100999 : Number(storedDate.occupation_second);
                        this.occupation_third = storedDate.occupation_third == '' ? 100999 : Number(storedDate.occupation_third);
                        console.log('Delayed for 1 second.');
                    }

                    setTimeout(() => {
                        this.getPositionslist();
                    }, 500);
                }, 100);
            });
        },
        resetPosition() {
            this.disablesecond = true;
            this.disablethird = true;
            this.occupation_first = '';
            this.occupation_second = '';
            this.occupation_third = '';
            this.Tertiarydropdown = [];
            this.SeconddropdownValue = [];
            // this.pagination.pagination_limit = '';
            this.getPositionslist();
        },
        getSecondOccupationList() {
            const filteredObject = this.Primarydropdown.find((item) => item.id === this.occupation_first);
            const filteredText = filteredObject ? filteredObject.text : '';
            if (this.occupation_first == '') {
                // alert('Please select first level occupation');
                if (localStorage.getItem('prev_offered_path') == 'Position Offered') {
                    console.log('noText');
                } else {
                    this.$toast.add({ severity: 'error', summary: '에러 메시지.', detail: '직무를 선택해 주세요', life: 3000 });
                }
            } else {
                // alert(this.occupation_first)
                this.positionOfferService.SecondOccupation(this.occupation_first).then((res) => {
                    // alert(this.occupation_first)
                    const obj = { id: 100999, text: `${filteredText} 전체` };
                    res.unshift(obj);
                    this.SeconddropdownValue = res;
                    console.log(this.SeconddropdownValue);
                    this.disablesecond = false;
                });
            }
        },
        getThirdOccupationList() {
            let checkthird = JSON.parse(localStorage.getItem('SearchParams'));
            const filteredObject = this.SeconddropdownValue.find((item) => item.id === this.occupation_second);
            const filteredText = filteredObject ? filteredObject.text : '';
            if (this.occupation_second == '' || this.occupation_second == 100999) {
                // alert('Please select second level occupation');
                if (localStorage.getItem('prev_offered_path') == 'Position Offered') {
                    if (checkthird == 100999) {
                        this.occupation_third = 100999;
                    } else {
                        this.occupation_third = '';
                    }
                    console.log('noText');
                } else {
                    this.$toast.add({ severity: 'error', summary: '에러 메시지.', detail: '직무를 선택해 주세요', life: 3000 });
                }
            } else {
                this.positionOfferService.ThirdOccupation(this.occupation_second).then((res) => {
                    const obj = { id: 100999, text: `${filteredText} 전체` };
                    res.unshift(obj);
                    // res.unshift(JSON.parse('{"id": 10999, "text": "전체"}'));
                    this.Tertiarydropdown = res;
                    console.log(this.Tertiarydropdown);
                    this.disablethird = false;
                });
            }
        },
        addDay(val) {
            const date = new Date(val);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (val = yyyy + '-' + mm + '-' + dd);
        },
        FindSeeker(id) {
            if (this.occupation_first != '' && this.searchclicked == true) {
                localStorage.setItem(
                    'SearchParams',
                    JSON.stringify({
                        page: this.pagination.current_page,
                        limit: this.pagination.pagination_limit,
                        occupation_first: this.occupation_first,
                        occupation_second: this.occupation_second == 100999 ? '' : this.occupation_second,
                        occupation_third: this.occupation_third == 100999 ? '' : this.occupation_third,
                        checkthird: this.occupation_third == '' ? 100999 : '',
                    })
                );
                this.$router.push('/PositionOffer/PositionOffered/' + id);
            } else {
                if (localStorage.getItem('prev_offered_path') == 'Position Offered') {
                    console.log('noText');
                } else {
                    this.$toast.add({ severity: 'error', summary: '에러 메시지.', detail: '직무를 선택해 주세요', life: 3000 });
                }
            }
        },
        searchTable() {
            let searchParams = {
                page: this.pagination.current_page,
                limit: this.pagination.pagination_limit,
                occupation_first: this.occupation_first,
                occupation_second: this.occupation_second == 100999 ? '' : this.occupation_second,
                occupation_third: this.occupation_third == 100999 ? '' : this.occupation_third,
            };
            localStorage.setItem('SearchParams', JSON.stringify(searchParams));
            this.searchclicked = true;
            this.loading = true;
            this.positionOfferService
                .getPositionOfferList(searchParams)
                .then((res) => {
                    this.Positions = res.data.data;
                    this.totalrecords = res.data.total_records;
                    // this.occupation_first = res.data.default_occu_first_level;
                    this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                    this.loading1 = false;
                    console.log(res);
                })
                .catch(() => {
                    this.results = [];
                    this.loading1 = false;
                });
        },

        searchPosition() {
            this.pagination.current_page = 1;
            if (this.occupation_first == '' && this.occupation_second == '' && this.occupation_third == '') {
                // console.log(this.productCategoryStatus);
                if (localStorage.getItem('prev_offered_path') == 'Position Offered') {
                    console.log('noText');
                } else {
                    this.$toast.add({ severity: 'error', summary: '에러 메시지.', detail: '직무를 선택해 주세요', life: 3000 });
                }
            } else if (this.occupation_first != '' && this.occupation_second == '') {
                if (localStorage.getItem('prev_offered_path') == 'Position Offered') {
                    console.log('noText');
                } else {
                    this.$toast.add({ severity: 'error', summary: '에러 메시지.', detail: '직무를 선택해 주세요', life: 3000 });
                }
            } else if (this.occupation_second != 100999) {
                if (this.occupation_second != 100999 && this.occupation_third == '') {
                    if (localStorage.getItem('prev_offered_path') == 'Position Offered') {
                        console.log('noText');
                    } else {
                        this.$toast.add({ severity: 'error', summary: '에러 메시지.', detail: '직무를 선택해 주세요', life: 3000 });
                    }
                } else {
                    this.searchTable();
                    // alert('001');
                }
            } else {
                this.searchTable();
                // alert('002');
            }
        },
        exceldownload() {
            this.productCategoryService.getExcel(this.first_category, this.second_category, this.third_category, this.productCategoryStatus?.code).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Productcategorylist.xlsx'); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        today() {
            const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '.');
            this.start_date = utc;
            this.end_date = utc;
            this.getlist();
            console.log(this.start_date);
        },
        lastweek() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 7);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        lastmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 31);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        lastsixmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 182);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        getParams(NotificationType) {
            localStorage.setItem('NotificationType', NotificationType);
            console.log(NotificationType);
        },
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },

        onRowExpand(event) {
            this.$toast.add({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
        },
        onRowCollapse(event) {
            this.$toast.add({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
        },
        expandAll() {
            this.expandedRows = this.products.filter((p) => p.id);
            this.$toast.add({ severity: 'success', summary: 'All Rows Expanded', life: 3000 });
        },
        collapseAll() {
            this.expandedRows = null;
            this.$toast.add({ severity: 'success', summary: 'All Rows Collapsed', life: 3000 });
        },
        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        formatDate(value) {
            const date = new Date(value);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (value = yyyy + '.' + mm + '.' + dd);
        },
        calculateCustomerTotal(name) {
            let total = 0;
            if (this.customer3) {
                for (let customer of this.customer3) {
                    if (customer.representative.name === name) {
                        total++;
                    }
                }
            }

            return total;
        },

        confirm(id) {
            var self = this;
            this.$confirm.require({
                group: 'dialog',
                header: '확인',
                message: '삭제하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    axios({ method: 'delete', url: `/product-category/${id}` }).then(function () {});
                    self.$toast.add({ severity: 'info', summary: '삭제', detail: '성공적으로 삭제되었습니다.', life: 3000 });
                    self.productCategoryService.getProductCategoryList(self.first_category, self.second_category, self.third_category, self.productCategoryStatus).then((data) => {
                        console.log(data);
                        this.customer1 = data;
                        this.loading1 = false;
                        this.customer1.forEach((customer) => (customer.createdDate = new Date(customer.createdDate)));
                    });
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: '오류가 발생했습니다', detail: '취소되었습니다', life: 3000 });
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.p-datatable-tbody {
    .p-button {
        white-space: nowrap;
    }
}

.p-fluid {
    .p-button {
        width: auto;
    }
}

.p-button {
    background: white;
    border: 1px solid blue;
    color: black;
}

// .p-button1 {
//     background-color: black;
//     color: white;
//     border-color: black;
// }
button.p-button.p-component.p-button2.p-component.p-button.p-button-sm.p-mr-2.p-mb-2 {
    border: 1px solid blue;
    color: black;
    background: white;
}
button.p-button.p-component.p-button2:hover {
    background: black;
    color: white;
    // border: 1px solid black;
    border-color: black;
}
button.p-button.p-component.p-button2 {
    background: rgb(255, 253, 253);
    color: rgb(10, 10, 10);
    border: 1px solid black;
    border-color: black;
}
</style>
